import {
    LEADERS_UPDATE,
    FETCH_LEADERS_ERROR,
    FETCH_LEADERS_SUCCESS,
    FETCH_LEADERS_LOADING,
    FETCH_USER_NUM_SUCCESS
} from '../constants/action-types';
const initialState = {
    leaders: [],
    error: null,
    leadersLoading: false,
    userNumber: 0
};


export default (state = initialState, action) => {

    switch (action.type) {
        case FETCH_LEADERS_LOADING: 
            {
                return Object.assign({},
                    state, {
                        leadersLoading: true
                    })
            }
        case FETCH_LEADERS_SUCCESS: 
            {
                return Object.assign({},
                    state, {
                        leadersLoading: false,
                        leaders: action.payload,
                        error: null
                    })
            }
            case FETCH_USER_NUM_SUCCESS: 
            {
                return Object.assign({},
                    state, {                       
                        userNumber: action.payload                        
                    })
            }
        case FETCH_LEADERS_ERROR:
            {
                return Object.assign({},
                    state, {
                        error: action.payload
                    })
            }
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/reducers/leader-reducer.js